import React from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalHeader, ModalBody, Button, Alert} from 'reactstrap';
import {FormattedMessage} from "react-intl";
import Formsy from 'formsy-react';
import InputFormGroup from "components/Form/InputFormGroup";
import DualInputFormGroup from "components/Form/DualInputFormGroup";
import Loading from "components/Loading";
import {getStatusFromError} from "helpers/errors";
import {formatPhone} from "helpers/phone";

class CustomerInfoEdit extends React.Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        advertName: PropTypes.string.isRequired,
        conversationTitle: PropTypes.string.isRequired,
        info: PropTypes.object.isRequired,
        onTitleChange: PropTypes.func.isRequired,
        onInfoChange: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.addEntry = this.addEntry.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentWillMount() {
        this.setState({
            infoEntries: Object.entries(this.props.info),
            opened: false
        });
    }

    componentWillReceiveProps(props) {
        this.setState({
            infoEntries: Object.entries(props.info)
        });
    }

    toggle() {
        this.setState({
            opened: !this.state.opened
        });
    }

    addEntry() {
        const newEntries = this.state.infoEntries.slice(0);
        newEntries.push(['', '']);
        this.setState({
            infoEntries: newEntries
        });
    }

    removeEntry(idx) {
        const newEntries = this.state.infoEntries.slice(0);
        newEntries.splice(idx, 1);
        this.setState({
            infoEntries: newEntries
        });
    }

    submit(model) {
        this.setState({
            loading: true,
        });

        const title = model.title;
        if (title !== this.props.conversationTitle) {
            this.props.onTitleChange(title);
        }

        const infoModel = Object.assign({}, model);
        delete infoModel.title;

        const info = {};
        for (let i = 0; i < this.state.infoEntries.length; ++i) {
            if (infoModel[i + '-value'] !== '') {
                info[infoModel[i + '-key']] = infoModel[i + '-value'];
            }
        }

        this.props.onInfoChange(info).then(() => {
            this.setState({
                loading: false,
                opened: false,
            });
        }).catch(e => {
            this.setState({
                loading: false,
                status: getStatusFromError(e),
            });
        });
    }

    render() {
        const {status, loading, valid} = this.state;
        const {id, advertName, conversationTitle} = this.props;

        return (
            <span className="mr-3">
                <a tabIndex={2} className="clickable" onClick={this.toggle}>
                    <FormattedMessage id="conversation.edit_customer_info" defaultMessage="Edit customer info"/>
                </a>
                <Modal keyboard autoFocus isOpen={this.state.opened} modalClassName="modal-small" toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        <FormattedMessage id="conversation.customer_info.title" defaultMessage="Customer"/><br/>
                        <span className="ml-auto align-self-end pb-1 text-muted">
                            <FormattedMessage id="conversation.edit_customer_info.id" defaultMessage="Phone number" />
                            <span>: {(/^(\+?\d+)/.test(id) ? formatPhone(id) : id)}</span>
                        </span>
                    </ModalHeader>
                    <ModalBody>
                        <Formsy className="form" onValid={() => this.setState({valid: true})}
                                onInvalid={() => this.setState({valid: false})} onValidSubmit={this.submit}>
                            <InputFormGroup type="text" name="title" required value={conversationTitle} label={(
                                <FormattedMessage id="conversation.customer_info.title_label"
                                                  defaultMessage="Conversation title"/>)}
                            />

                            <p className="text-muted">
                                <FormattedMessage id="conversation.customer_info.text" values={{advert: advertName}}
                                                  defaultMessage="What customer said about himself in conversation with {advert}"/>:
                            </p>
                            {this.state.infoEntries.map((entry, idx) => (
                                <FormattedMessage key={"dual-input-key-message-" + idx}
                                                  id="conversation.operator_info.key_input.placeholder"
                                                  defaultMessage="e.g. sex" children={(keyMessage) => (
                                    <FormattedMessage id="conversation.operator_info.value_input.placeholder"
                                                      defaultMessage="e.g. male" children={(valueMessage) => (
                                        <DualInputFormGroup key={"dual-input-" + idx}
                                                            inputProps={{
                                                                key: {placeholder: keyMessage},
                                                                value: {placeholder: valueMessage}
                                                            }}
                                                            onRemove={() => ::this.removeEntry(idx)}
                                                            name={idx.toString(10)} values={entry}/>
                                    )}/>
                                )}/>
                            ))}

                            <p>
                                <a tabIndex={10} onClick={this.addEntry} className="clickable">
                                    <FormattedMessage id="conversation.customer_info.add_next"
                                                      defaultMessage="Add next"/>
                                </a>
                            </p>

                            {status &&
                            <Alert color={status.type}>
                                {status.message}
                            </Alert>
                            }

                            <Button type="submit" color="secondary" block
                                    disabled={!valid || loading}>
                                {loading &&
                                <Loading inline small/>
                                }
                                <FormattedMessage id="conversation.customer_info.save" defaultMessage="Save"/>
                            </Button>
                        </Formsy>
                    </ModalBody>
                </Modal>
            </span>
        )
    }
}

export default CustomerInfoEdit;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Title/CustomerInfoEdit.jsx